import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError, tap, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  token: any;
  tokenChanges: Subject<any> = new Subject<any>();

  public login(email: string, password: string) {
    return this.http.post(`${environment.apiUrlTemp}/auth/login`, { email, password }).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
      tap((res: any) => {
        return res;
      })
    );
  }

  public register(email: string, publicKey: string) {
    return this.http.post(`${environment.apiUrl}/user/create/reader`, { email, public_key: publicKey }).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
      tap((res: any) => {
        return res;
      })
    );
  }

  public loginToken(token: string) {
    return this.http.post(`${environment.apiUrl}/login`, { token }).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
      tap((res: any) => {
        return res;
      })
    );
  }

  public getToken() {
    return localStorage.getItem('token');
    return this.token;
  }

  public logout() {

    // localStorage.removeItem('token');
    // localStorage.removeItem('company_id');
    // localStorage.removeItem('chatId');
    // window.location.href = '/login';

    const isGuest = localStorage.getItem('is_guest');

    localStorage.removeItem('token');
    localStorage.removeItem('company_id');
    localStorage.removeItem('chatId');
    localStorage.removeItem('is_guest');
    

    if (isGuest === 'true') {
      window.location.href = '/guest-auth';
    } else {
      window.location.href = '/login';
    }
  }

  public isAuthenticated() {
    return !!localStorage.getItem('token');
    return (!!localStorage.getItem('token') || !!this.token);
    // return !!this.token;
  }

  public setToken(token: string) {
    this.token = token;
    this.tokenChanges.next(token);
  }
}
